<template>
  <div class="yuyueguahao">
    <van-loading v-if="loading" class="my-loading" type="spinner" color="#1989fa" />
    <div v-if="!loading && (doctorDetail.length>0 || commonDetail.length>0)">
      <div v-if="doctorDetail.length>0" class="yishengliebiao">{{ doctorDetail[0].doctorName }}</div>
      <div v-else-if="doctorDetail.length===0 && commonDetail.length>0" class="yishengliebiao">{{ commonDetail[0].doctorName }}</div>
      <div class="doctor">
        <div class="img-wrap">
          <!-- <img v-if="doctorSex==='8'" class="doctor-img" src="../../assets/images/doctor_pic.png" />
           <img v-else-if="doctorSex==='7'" class="doctor-img" src="../../assets/images/doctor_pic_man.png" /> -->
          <img class="doctor-img" src="../../assets/images/doctor.png">
        </div>
        <div class="info-wrap">
          <div v-if="doctorDetail.length>0" class="name">{{ doctorDetail[0].doctorName }}</div>
          <div v-else-if="doctorDetail.length===0 && commonDetail.length>0" class="name">{{ commonDetail[0].doctorName }}</div>
          <div style="display:flex;margin-top:15px;">
            <div class="title-wrap">
              <div class="title-img">
                <img class="v-img" src="../../assets/images/v_pic.png">
              </div>
              <div v-if="doctorDetail.length>0" class="title">{{ doctorDetail[0].titleName }}</div>
              <div v-else-if="doctorDetail.length===0 && commonDetail.length>0" class="title">{{ commonDetail[0].titleName }}</div>
            </div>
          </div>
        </div>
      </div>
      <van-tabs v-model="active">
        <van-tab v-if="doctorDetail.length>0" title="专家号">
          <ul class="list-wrap">
            <li v-for="(item,index) in doctorDetail" :key="index" class="list">
              <div v-for="(item2,index2) in item.noonAllDay" :key="index2" class="list-items" @click="doctorInfoFun(item,item.noon)">
                <p class="times"><span>{{ item.diagnoseDate }}</span>&nbsp;&nbsp;<span>{{ item.week }}</span>&nbsp;&nbsp;<span>{{ item2.noonName }}</span></p>
                <div class="info">
                  <div class="title"><span>{{ item.deptName }}</span>
                  <!-- &nbsp;&nbsp;<span>专家</span>  -->
                  </div>
                  <div v-if="item.keepNumbers" class="yuhao">余号：{{ item.keepNumbers }}</div>
                  <div v-else class="yuhao">今日预约已满</div>
                  <div class="price">￥{{ item.price }}元</div>
                </div>
                <DeptTips :item="item" />
              </div>

            </li>
            <noData v-if="!loading && doctorDetail.length===0" title="暂无数据" />
          </ul>
        </van-tab>
        <van-tab v-if="commonDetail.length>0" title="普通号">
          <ul class="list-wrap">
            <li v-for="(item,index) in commonDetail" :key="index" class="list">
              <div v-for="(item2,index2) in item.noonAllDay" :key="index2" class="list-items" @click="doctorInfoFun(item,item2.noon)">
                <p class="times"><span>{{ item.diagnoseDate }}</span>&nbsp;&nbsp;<span>{{ item.week }}</span>&nbsp;&nbsp;<span>{{ item2.noonName }}</span></p>
                <div class="info">
                  <div class="title"><span>{{ item.deptName }}</span>
                  <!-- &nbsp;&nbsp;<span>专家</span>  -->
                  </div>
                  <div class="yuhao">余号：{{ item.keepNumbers }}</div>
                  <div class="price">￥{{ item.price }}元</div>
                </div>
                <DeptTips :item="item" />
              </div>

            </li>
            <noData v-if="!loading && commonDetail.length===0" title="暂无数据" />
          </ul>
        </van-tab>
      </van-tabs>

    </div>
    <noData v-if="!loading && commonDetail.length===0 && doctorDetail.length===0" title="暂无数据" />
  </div>
</template>

<script>
import DeptTips from '@/components/DeptTips'
export default {
  name: 'ZhuanJiaGuaHao',
  components: {
    DeptTips
  },
  data() {
    return {
      doctorDetail: [],
      commonDetail: [],
      doctorCode: '',
      loading: false,
      deptCode: '',
      doctorSex: '',
      active: 0,
      type: ''
    }
  },
  created() {
    this.doctorCode = this.$route.query.doctorCode
    this.deptCode = this.$route.query.deptCode
    this.doctorSex = this.$route.query.doctorSex
    this.type = this.$route.query.type
    this.getData()
  },
  mounted() {

  },
  methods: {
    getData() {
      this.loading = true
      this.$Apis.getGjyyDoctorKeeps({
        doctorCode: this.doctorCode,
        campusArea: this.type
      }).then(res => {
        if (res.code === 200) {
          this.doctorDetail = res.data.export || []
          this.commonDetail = res.data.common || []
        } else {
          this.$toast(res.message)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$toast(err.message)
      })
    },
    // 挂号 预约 医生
    doctorInfoFun(item, noon) {
      if (item.keepNumbers) {
        localStorage.setItem('titleCode', item.titleCode || '')
        this.$router.push(`/yishengpaiban?doctorCode=${item.doctorCode}&deptCode=${this.deptCode}&time=${item.diagnoseDate}&noon=${noon}`)
        /* if (item.deptCode === '0104') {
          this.$dialog.alert({
            title: '提示',
            message: '需另收心理专家咨询费270元/次（不包含其他的检查治疗费用）'
          }).then(() => {
            this.$router.push(`/yishengpaiban?doctorCode=${item.doctorCode}&deptCode=${this.deptCode}&time=${item.diagnoseDate}&noon=${noon}`)
          })
        } else {
          this.$router.push(`/yishengpaiban?doctorCode=${item.doctorCode}&deptCode=${this.deptCode}&time=${item.diagnoseDate}&noon=${noon}`)
        } */
      } else {
        this.$toast({
          message: '余号不足',
          position: 'top',
          duration: 500
        })
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.yuyueguahao{
  width: 100%;
  padding-bottom: 10px;
  .yishengliebiao{
    padding: 20px;
    background: #FFFFFF;
    text-align: center;
    font-size: 16px;
    color: #555555;
  }
  .doctor{
      display: flex;
      padding: 20px 8px ;
      background: #FFFFFF;
      margin: 10px;
      border-radius: 8px;
      .img-wrap{
        width: 62px;
        height: 62px;
        border-radius: 50%;
        flex-shrink: 0;
        margin-right: 10px;
        overflow: hidden;
        .doctor-img{
          width: 62px;
        height: 62px;
        }
      }
      .info-wrap{
        flex: 1;
        .name{
          font-size: 16px;
          color: #2C2C2C;
        }
        .title-wrap{
          display: flex;
          background: #1777FF;
          align-items: center;
          padding: 2px;
          padding-right: 10px;
          border-radius: 9px;
          .title-img{
            width: 14px;
            height: 14px;
            .v-img{
              width: 14px;
            height: 14px;
            }
          }
          .title{
            color: #FFFFFF;
            margin-left: 4px;
            font-size: 10px ;
          }
        }
      }
    }
  .list-wrap{
    margin: 10px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 12px;

    .list{

      .list-items{
        padding: 20px 8px ;
        border-bottom: 1px solid #E6E6E6;
        &:last-child{
          border:none;
        }
        .times{
          color: #333333;
          font-size: 15px;
        }
        .info{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 12px;
          .title{
            font-size: 14px;
            color: #666666;
          }
          .yuhao{
            color: #FD9F26;
          }
          .price{
            padding: 4px 12px;
            color: #fff;
            background: #2B8CFF;
            border-radius: 12px;
          }
        }
      }
    }
  }
}
</style>
